import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './PurchaseOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public PurchaseOrders: PurchaseOrders_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
